import React, { useCallback } from 'react';
import { __ } from 'first-intl';
import { FormButtons, useProgress } from '@hugendubel/react-basic';
import { OrderService } from '../../../services/order-service';
import { ReducedProduct } from '../../../ws/result/ReducedProduct';

export type ConfirmPickupProps = { article: ReducedProduct; close: () => Promise<void> };

export const ConfirmPickup: React.FC<ConfirmPickupProps> = ({ close, article }) => {
    const [loading, withProgress] = useProgress();

    const onSubmit = useCallback(() => {
        withProgress(() => OrderService.pickup(article));
    }, [withProgress, article]);

    return (
        <div>
            <p>{__('modal.pickup.confirmation.text')}</p>
            <FormButtons
                onSubmit={onSubmit}
                submitLabel="modal.pickup.confirmation.button.confirm"
                abortLabel="modal.pickup.confirmation.button.cancel"
                loading={loading}
                onAbort={close}
            />
        </div>
    );
};
